/**
 * Return true if the given param has 'eVineyard' (case-insensitive).
 */
export function isEVineyardTarget(target?: string | null): boolean {
  return target?.toLowerCase() === 'evineyard';
}
